import React from 'react';

const GlassProductsIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22" fill="none" {...rest}>
      <path d="M3.53445 21H7.53445M7.53445 21H11.5344M7.53445 21V14M7.53445 14C7.53445 14 3.31745 11.682 2.11245 9.048C0.812446 6.203 2.11245 1 2.11245 1H12.9564C12.9564 1 14.2564 6.203 12.9564 9.048C11.7514 11.682 7.53445 14 7.53445 14Z" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.03442 1L6.03442 5H9.03442L7.03442 9" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default GlassProductsIcon;